module.exports = __webpack_public_path__ + "static/media/EarthDayRecipeBook.809f05be.PNG";